import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStreamPlatformSoop = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Icons",
		children: /* @__PURE__ */ _jsx("g", {
			id: "StreamingPlatform",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Platform=Soop",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group 1",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "Vector",
							d: "M19.4059 11.6335C18.1125 11.6335 16.9506 12.196 16.1511 13.0894C16.117 13.1278 16.0576 13.1278 16.0236 13.0894C15.2241 12.196 14.0621 11.6335 12.7688 11.6335C10.3572 11.6335 8.40234 13.5884 8.40234 16C8.40234 18.4116 10.3572 20.3665 12.7688 20.3665C14.0621 20.3665 15.2241 19.8041 16.0236 18.9107C16.0576 18.8723 16.117 18.8723 16.1511 18.9107C16.9506 19.8041 18.1125 20.3665 19.4059 20.3665C21.8175 20.3665 23.7723 18.4116 23.7723 16C23.7723 13.5884 21.8175 11.6335 19.4059 11.6335ZM19.4059 18.2706C18.7072 18.2706 18.1234 17.9339 17.7654 17.5536C17.6514 17.4322 17.5099 17.2659 17.3545 17.1248C17.2803 17.0576 17.2065 16.9973 17.1357 16.9432C16.8436 16.7349 16.4812 16.6113 16.0878 16.6113C15.6943 16.6113 15.3319 16.7349 15.0398 16.9432C14.9687 16.9973 14.8953 17.0576 14.821 17.1248C14.6652 17.2659 14.5241 17.4322 14.4102 17.5536C14.0521 17.9339 13.4683 18.2706 12.7697 18.2706C12.7518 18.2706 12.7343 18.2697 12.7164 18.2693C12.6863 18.2684 12.6562 18.2675 12.6265 18.2658C12.606 18.2645 12.5854 18.2628 12.5653 18.261C12.5531 18.2601 12.5409 18.2588 12.5291 18.2579C11.3881 18.1378 10.4991 17.1729 10.4991 16V16.0096C10.4991 16.0031 10.4991 15.9965 10.4991 15.9904V16C10.4991 14.8276 11.3881 13.8627 12.5287 13.7421C12.5413 13.7408 12.5544 13.74 12.5671 13.7386C12.5867 13.7369 12.6064 13.7356 12.626 13.7343C12.6562 13.7325 12.6863 13.7317 12.7168 13.7308C12.7343 13.7308 12.7518 13.7295 12.7692 13.7295C13.4679 13.7295 14.0517 14.0661 14.4097 14.4464C14.5237 14.5678 14.6652 14.7342 14.8206 14.8752C14.8949 14.9425 14.9687 15.0027 15.0394 15.0569C15.3315 15.2652 15.6939 15.3887 16.0873 15.3887C16.4808 15.3887 16.8432 15.2652 17.1353 15.0569C17.2065 15.0027 17.2798 14.9425 17.3541 14.8752C17.5099 14.7342 17.651 14.5678 17.7649 14.4464C18.123 14.0661 18.7068 13.7295 19.4054 13.7295C19.4229 13.7295 19.4399 13.7303 19.4574 13.7308C19.4879 13.7317 19.5185 13.7325 19.5486 13.7343C19.5678 13.7356 19.5871 13.7369 19.6063 13.7386C19.6198 13.7395 19.6333 13.7408 19.6469 13.7421C20.7437 13.8583 21.6074 14.7551 21.6716 15.8668C21.6716 15.8743 21.6725 15.8813 21.6729 15.8882C21.6738 15.9088 21.6743 15.9297 21.6747 15.9503C21.6751 15.9813 21.6756 16.0118 21.6747 16.0428C21.6743 16.066 21.6742 16.0895 21.6729 16.1127C21.6729 16.1175 21.672 16.1223 21.672 16.1271C21.6105 17.241 20.7455 18.1409 19.6469 18.2571C19.6329 18.2584 19.6194 18.2597 19.6054 18.2605C19.5866 18.2623 19.5678 18.2636 19.5491 18.2649C19.5189 18.2667 19.4879 18.2675 19.4574 18.2684C19.4399 18.2684 19.4229 18.2697 19.4054 18.2697L19.4059 18.2706Z",
							fill: "url(#paint0_linear_4346_6138)"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_2",
							d: "M4.46509 14.801L5.76412 15.2228C5.95709 15.3014 6.65572 15.476 7.17972 16C7.66219 16.4825 7.87836 17.1283 7.87836 17.7567C7.87836 19.6679 5.90558 20.3665 4.4725 20.3665C2.28926 20.3665 1.34785 19.3998 1.06665 19.1439L2.35738 17.4947C2.44864 17.6187 3.33722 18.4453 4.4725 18.4453C4.90916 18.4453 5.60779 18.2706 5.60779 17.7466C5.60779 17.3973 5.24928 17.1222 4.4725 16.8733L3.17391 16.4511C2.28053 16.097 1.59063 15.476 1.59063 14.2534C1.59063 13.584 1.84781 13.0745 1.96527 12.892C2.69141 11.7615 4.14415 11.6335 4.64717 11.6335C5.53179 11.6335 6.18548 11.7969 6.65966 11.9973C7.26181 12.2519 7.57488 12.5662 7.70369 12.6815L6.62737 14.057C5.39907 13.2972 4.63361 13.3539 4.21052 13.5041C3.92233 13.6063 3.83062 13.836 3.81751 13.9845C3.80138 14.1674 3.83062 14.5639 4.46509 14.8006V14.801Z",
							fill: "currentColor"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_3",
							d: "M28.1387 11.6772H24.6455V20.3228H26.7414V17.441H28.1387C29.6098 17.441 30.9332 16.5677 30.9332 14.5591C30.9332 12.5505 29.6098 11.6772 28.1387 11.6772ZM28.8373 14.5591C28.8373 15.1861 28.3291 15.6944 27.7021 15.6944H26.7414V13.4238H27.7021C28.3291 13.4238 28.8373 13.9321 28.8373 14.5591Z",
							fill: "currentColor"
						})
					]
				})
			})
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_4346_6138",
		x1: 9.97256,
		y1: 11.2179,
		x2: 22.7405,
		y2: 21.1479,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#0082FF" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .42,
				stopColor: "#0A96FF"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .56,
				stopColor: "#05BCFF"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .76,
				stopColor: "#00F0FF"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .79,
				stopColor: "#04F0FC"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .82,
				stopColor: "#10F1F5"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .85,
				stopColor: "#24F4E8"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .89,
				stopColor: "#40F7D7"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .92,
				stopColor: "#64FBC1"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .94,
				stopColor: "#82FFB0"
			})
		]
	}) })]
});
export default SvgStreamPlatformSoop;
